import { useContext } from "react";
import { useMutation, useQueryClient } from "react-query";
import axios from "axios";
import { MisAPI } from "../../../constants/API";
import { commonHeaders } from "../../../constants/HeadersAPI";
import { defaultSuccessMessage } from "../../../constants/alertText";
import { AlertContext } from "../../../context/AlertProvider";
import { AlertType } from "../../../types/enums";
import {
  MisQueueSettingsDto,
  MisQueueSettingsRequest,
} from "../../../types/Mis/MisTypes";

export const usePutMisQueueSettings = (branchQueueId: number | null) => {
  const queryClient = useQueryClient();
  const context = useContext(AlertContext);
  return useMutation(
    (payload: MisQueueSettingsRequest) =>
      axios.put<MisQueueSettingsDto>(
        MisAPI.updateQueueSettings(branchQueueId!),
        payload,
        commonHeaders(),
      ),
    {
      onSuccess: () => {
        queryClient
          .invalidateQueries(["misQueueSettings", branchQueueId])
          .then(() =>
            context?.setAlert({
              type: AlertType.Success,
              message: defaultSuccessMessage,
            }),
          );
      },
    },
  );
};
